import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Move Attribution to bottom left of the Leaflet map

function Attribution() {
    const map = useMap();

    useEffect(() => {
        map.attributionControl && map.attributionControl.remove();
        L.control.attribution({
            position: 'bottomleft',
        }).addTo(map);
    }, [map]);

    return null;
}

export default Attribution;